import { Injectable } from '@angular/core';
import { environment} from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  constructor(private http: HttpClient) {
  }

  //
  // Get ADP-synced employees for a client
  //
  getEmployees( client_id: any, include_inactive: any = false ): Observable<any> {
    return this.http.get(`${environment.apiUrl}employee/client/` + client_id +
                 '?include_inactive=' + include_inactive)
       .pipe(map((res: any) => {
         return res;
       }));
  }

  //
  // Trigger an ADP employee sync for a client
  //
  syncNow( client_id: any ): Observable<any> {
    return this.http.post(`${environment.apiUrl}employee/client/` + client_id + '/sync', {})
       .pipe(map((res: any) => {
         return res;
       }));
  }

}
